import { StyleSheet } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';

export const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    scrollContent: {
      flexGrow: 1,
      padding: 20,
      paddingBottom: 40,
    },
    logoSection: {
      alignItems: 'center',
      marginBottom: 24,
    },
    logoCircle: {
      width: 90,
      height: 90,
      borderRadius: 45,
      borderWidth: 2,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 10,
    },
    logoImage: {
      width: 90,
      height: 90,
      borderRadius: 45,
    },
    logoButton: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderRadius: 8,
      borderWidth: 1,
    },
    logoButtonText: {
      fontSize: 14,
      fontWeight: '500',
    },
    label: {
      fontSize: 14,
      fontWeight: '600',
      marginBottom: 6,
    },
    input: {
      borderWidth: 1,
      borderRadius: 10,
      padding: 12,
      fontSize: 16,
      marginBottom: 16,
    },
    textArea: {
      height: 80,
      textAlignVertical: 'top',
    },
    visibilityRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 14,
      paddingHorizontal: 16,
      borderWidth: 1,
      borderRadius: 10,
      marginBottom: 16,
    },
    visibilityTextBlock: {
      flex: 1,
      marginRight: 12,
    },
    visibilityLabel: {
      fontSize: 15,
      fontWeight: '600',
    },
    visibilityDesc: {
      fontSize: 12,
      marginTop: 2,
    },
    buttonRow: {
      flexDirection: 'row',
      gap: 12,
      marginTop: 10,
    },
    primaryButton: {
      flex: 1,
      backgroundColor: colors.primary,
      borderRadius: 10,
      padding: 16,
      alignItems: 'center',
    },
    primaryButtonText: {
      color: colors.primaryText,
      fontSize: 16,
      fontWeight: '600',
    },
    secondaryButton: {
      flex: 1,
      backgroundColor: colors.card,
      borderRadius: 10,
      padding: 16,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: colors.border,
    },
    secondaryButtonText: {
      color: colors.text,
      fontSize: 16,
      fontWeight: '600',
    },
    disabledButton: {
      opacity: 0.6,
    },
  });
